import { type Locale } from '@lib/language'
import { getShopifyStorefrontGraphQlClient } from './graphql/client'
import { getShopifyProduct } from './graphql/product'

export const shopifyColorOptionNames: string[] = ['Color']

/**
 * Determines if product is available for storefront API (app or sales channel).
 */
export const getIsProductAvailable = async (
  locale: Locale,
  shopifyProductId: string,
) => {
  const shopifyStorefrontGraphQlClient =
    getShopifyStorefrontGraphQlClient(locale)
  const shopifyProduct = await getShopifyProduct(
    locale,
    shopifyStorefrontGraphQlClient,
    shopifyProductId,
  )

  return Boolean(shopifyProduct?.product)
}
